import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LPLogoWName } from "../../assets/index";
import { useUpdateNewPasswordMutation } from "./apiSlice";
import "./styles"
import styles from "./styles";
import { CheckCircledIcon } from "@radix-ui/react-icons";
import { CheckPasswordStrength } from "@Utils/common";
import { displayToast } from "@Utils/toast";
import { ROUTES } from "@Constants/routes";

const UpdatePassword = () => {


  const [password, setPassword] = useState<string>('')
  const [passwordConfirm, setPasswordConfirm] = useState<string>('')

  const navigate = useNavigate();

  const token = new URLSearchParams(useLocation().search).get('token');

  useEffect(() => {
    if (!token) navigate(ROUTES.LOGIN);
  }, [token])



  const [updateNewPassword, { data: updateNewPasswordData, error: updateNewPasswordErr, isLoading: updateNewPasswordLoading }] = useUpdateNewPasswordMutation();

  // const userLogin

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e?.target?.name == 'password') setPassword(e.target.value);
    if (e?.target?.name == 'password_confirm') setPasswordConfirm(e.target.value);
  };

  const onSubmitClick = (e: any) => {
    e.preventDefault()

    if (password !== passwordConfirm) {
      displayToast('error', 'Passwords are not matching')
      return
    };


    if (CheckPasswordStrength(password)) {
      updateNewPassword({ token, password })
    } else displayToast('error', 'Password weak!')
  }

  useEffect(() => {
    document.title = "LinkPlease - Update Password";
  }, []);

  useEffect(() => {
    if (updateNewPasswordData) {
      displayToast('success', updateNewPasswordData?.message)
      navigate(ROUTES.LOGIN)
    } else if (updateNewPasswordErr) {
      displayToast('error', updateNewPasswordErr?.data?.message || "Error Updating New Password")
    }
  }, [updateNewPasswordData, updateNewPasswordErr]);

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-cover bg-center bg-no-repeat bg-fixed"
      style={styles.LOGIN_CONTAINER}>
      <div className="w-[90%] max-w-[400px] flex flex-col items-center bg-white p-8 rounded-2xl">
        <div className="mb-8">
          <img src={LPLogoWName} className="w-[250px]" alt="Linkplease Logo" />
        </div>

        <div className="text-center mb-4">
          <h1 className="text-[1.2rem] font-semibold">Create New Password</h1>
        </div>

        <form onSubmit={onSubmitClick} className="w-full space-y-4">
          <div>
            <input
              type="password"
              name="password"
              autoComplete="false"
              onChange={handleChange}
              id="password"
              placeholder="Password"
              className="w-full px-4 py-3 rounded-lg bg-gray-50 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#7772FF] focus:border-transparent"
            />
          </div>
          <div>
            <input
              type="password"
              name="password_confirm"
              autoComplete="false"
              onChange={handleChange}
              id="password_confirm"
              placeholder="Confirm Password"
              className="w-full px-4 py-3 rounded-lg bg-gray-50 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#7772FF] focus:border-transparent"
            />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mt-2">
            <div className={`flex items-center gap-1 text-xs ${password.length >= 8 ? "text-emerald-500" : "text-red-500"}`}>
              <CheckCircledIcon className="w-4 h-4" />
              <span>Minimum 8 Characters</span>
            </div>
            <div className={`flex items-center gap-1 text-xs ${/(?=.*[a-z])(?=.*[A-Z])/.test(password) ? "text-emerald-500" : "text-red-500"}`}>
              <CheckCircledIcon className="w-4 h-4" />
              <span>Upper & Lower case</span>
            </div>
            <div className={`flex items-center gap-1 text-xs ${/\d/.test(password) ? "text-emerald-500" : "text-red-500"}`}>
              <CheckCircledIcon className="w-4 h-4" />
              <span>One Numerical (123)</span>
            </div>
            <div className={`flex items-center gap-1 text-xs ${/[!@#$%^&*(),.?":{}|<>]/.test(password) ? "text-emerald-500" : "text-red-500"}`}>
              <CheckCircledIcon className="w-4 h-4" />
              <span>Special Char (@#$%)</span>
            </div>
          </div>

          <button
            type="submit"
            disabled={updateNewPasswordLoading}
            className="w-full bg-[#3535d5] text-white py-3 rounded-lg font-medium hover:bg-[#6561FF] transition-colors disabled:opacity-50"
          >
            {updateNewPasswordLoading ? "Updating Password..." : "Update Password"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default UpdatePassword;
